module.exports = __webpack_public_path__ + "static/galileo-logo-8ddb9098ac8b976b5caee78cdc79432d.png";